// Keep viewport measurement and action focus handling on the same definition.
export const isTextEntry = element => Boolean(element?.matches?.(
  'input:not([type="checkbox"]):not([type="radio"]):not([type="range"]):not([type="file"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="image"]), textarea, [contenteditable="true"], [role="textbox"]'
));
